import { render, staticRenderFns } from "./ProductLists.vue?vue&type=template&id=00881c26&scoped=true"
import script from "./ProductLists.vue?vue&type=script&lang=js"
export * from "./ProductLists.vue?vue&type=script&lang=js"
import style0 from "./ProductLists.vue?vue&type=style&index=0&id=00881c26&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00881c26",
  null
  
)

export default component.exports